import { isTencentCharity } from '@/config/tencent-charity';

const NineDayDialogShowTag = 'NINE_DAY_DIALOG_SHOW_TAG';

export const useActTipDialog = () => {
  
  const setShowTag = () => {
    window.localStorage.setItem(NineDayDialogShowTag, '1');
  }

  const checkIfHadShow = () => {
    if (!isTencentCharity()) return true;
    const cache = window.localStorage.getItem(NineDayDialogShowTag) || '';
    return +cache === 1;
  }

  return {
    setShowTag,
    checkIfHadShow,
  }
}